import React, { useEffect, useLayoutEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./NovaLanding.css";
import "./PrivacyPolicy.css";
import ContactModal from "./ContactModal";

export default function TermsAndConditions() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [navShadow, setNavShadow] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);

  useLayoutEffect(() => {
    const scrollToTop = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;

      const scrollingElement = document.scrollingElement;
      if (scrollingElement) {
        scrollingElement.scrollTop = 0;
      }

      const root = document.getElementById("root");
      if (root) {
        root.scrollTop = 0;
      }
    };

    scrollToTop();
    const animationFrame = window.requestAnimationFrame(scrollToTop);
    const timeout = window.setTimeout(scrollToTop, 0);

    return () => {
      window.cancelAnimationFrame(animationFrame);
      window.clearTimeout(timeout);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setNavShadow(window.scrollY > 6);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleNav = () => {
    setMobileMenuOpen((open) => !open);
  };

  const openContactModal = (event) => {
    event?.preventDefault();
    setMobileMenuOpen(false);
    setShowContactModal(true);
  };

  const closeContactModal = () => {
    setShowContactModal(false);
  };

  return (
    <div className="privacy-page" data-testid="terms-page">
      <header id="nav" style={{ boxShadow: navShadow ? "0 2px 24px rgba(0,0,0,.35)" : "none" }}>
        <div className="container ni">
          <Link to="/landing" className="nl" aria-label="Nova landing page" data-testid="site-nav-logo-link">
            <img
              src="https://nova.bizacuity.ai/nova-logo.png"
              alt="Nova"
              className="nl-logo"
            />
          </Link>
          <nav className="nls">
            <Link to="/landing#aud" data-testid="site-nav-audience-link">Who&apos;s It For</Link>
            <Link to="/landing#feat" data-testid="site-nav-features-link">Features</Link>
            <Link to="/landing#ind" data-testid="site-nav-industries-link">Industries</Link>
            <Link to="/landing#price" data-testid="site-nav-pricing-link">Pricing</Link>
            <button type="button" className="nav-contact" onClick={openContactModal} data-testid="site-nav-contact-button">
              Contact
            </button>
          </nav>
          <div className="na">
            <Link className="nsi" to="/login" data-testid="site-nav-sign-in-link">
              Sign In
            </Link>
            {/* <Link className="nsi" to="/landing#price" data-testid="site-nav-view-pricing-link">
              View Pricing
            </Link> */}
          </div>
          <button className="hbg" onClick={toggleNav} aria-label="Toggle navigation" aria-expanded={mobileMenuOpen} data-testid="site-nav-mobile-menu-toggle-button">
            <svg viewBox="0 0 24 24">
              <line x1="3" y1="6" x2="21" y2="6" />
              <line x1="3" y1="12" x2="21" y2="12" />
              <line x1="3" y1="18" x2="21" y2="18" />
            </svg>
          </button>
        </div>
        <div id="mn" style={{ display: mobileMenuOpen ? "block" : "none" }}>
          <Link to="/landing#aud" onClick={toggleNav} data-testid="site-nav-mobile-audience-link">
            Who&apos;s It For
          </Link>
          <Link to="/landing#feat" onClick={toggleNav} data-testid="site-nav-mobile-features-link">
            Features
          </Link>
          <Link to="/landing#ind" onClick={toggleNav} data-testid="site-nav-mobile-industries-link">
            Industries
          </Link>
          <Link to="/landing#price" onClick={toggleNav} data-testid="site-nav-mobile-pricing-link">
            Pricing
          </Link>
          <button type="button" className="nav-contact mobile-nav-contact" onClick={openContactModal} data-testid="site-nav-mobile-contact-button">
            Contact
          </button>
          <div className="mobile-auth-actions">
            <Link className="mobile-auth-button mobile-auth-secondary" to="/login" onClick={toggleNav} data-testid="site-nav-mobile-sign-in-link">
              Sign In
            </Link>
            {/* <Link className="mobile-auth-button mobile-auth-secondary" to="/landing#price" onClick={toggleNav} data-testid="site-nav-mobile-view-pricing-link">
              View Pricing
            </Link> */}
          </div>
        </div>
      </header>

      <main className="privacy-main">
        <section className="privacy-hero">
          <p className="privacy-eye">Legal</p>
          <h1>Terms &amp; Conditions</h1>
          <p className="privacy-subtitle">Last updated: April 2026</p>
        </section>

        <aside className="privacy-toc">
          <h3>Contents</h3>
          <ol>
            <li><a href="#s1" data-testid="terms-toc-acceptance-of-terms-link">Acceptance of Terms</a></li>
            <li><a href="#s2" data-testid="terms-toc-description-of-services-link">Description of Services</a></li>
            <li><a href="#s3" data-testid="terms-toc-eligibility-link">Eligibility</a></li>
            <li><a href="#s4" data-testid="terms-toc-user-accounts-link">User Accounts</a></li>
            <li><a href="#s5" data-testid="terms-toc-acceptable-use-link">Acceptable Use</a></li>
            <li><a href="#s6" data-testid="terms-toc-content-ownership-link">Content Ownership</a></li>
            <li><a href="#s7" data-testid="terms-toc-guardrails-moderation-link">Guardrails &amp; Moderation</a></li>
            <li><a href="#s8" data-testid="terms-toc-audit-compliance-link">Audit &amp; Compliance</a></li>
            <li><a href="#s9" data-testid="terms-toc-payment-billing-link">Payment &amp; Billing</a></li>
            <li><a href="#s10" data-testid="terms-toc-intellectual-property-link">Intellectual Property</a></li>
            <li><a href="#s11" data-testid="terms-toc-disclaimer-of-warranties-link">Disclaimer of Warranties</a></li>
            <li><a href="#s12" data-testid="terms-toc-limitation-of-liability-link">Limitation of Liability</a></li>
            <li><a href="#s13" data-testid="terms-toc-termination-link">Termination</a></li>
            <li><a href="#s14" data-testid="terms-toc-governing-law-link">Governing Law</a></li>
            <li><a href="#s15" data-testid="terms-toc-changes-to-terms-link">Changes to Terms</a></li>
            <li><a href="#s16" data-testid="terms-toc-contact-link">Contact</a></li>
          </ol>
        </aside>

        <section className="privacy-section" id="s1">
          <h2>1. Acceptance of Terms</h2>
          <p>NOVA is an application designed by BizAcuity. By accessing or using Nova&apos;s Services, you agree to be bound by these Terms &amp; Conditions (&quot;Terms&quot;) and our Privacy Policy. If you do not agree, do not use the Services. These Terms form a legally binding agreement between you and Nova.</p>
        </section>

        <section className="privacy-section" id="s2">
          <h2>2. Description of Services</h2>
          <p>Nova provides an AI-powered knowledge platform that allows organisations to index documents, websites, and code repositories, and to surface information via chat interfaces, embeddable widgets, and third-party integrations such as Google Chat and Google Drive.</p>
        </section>

        <section className="privacy-section" id="s3">
          <h2>3. Eligibility</h2>
          <p>You must be at least 18 years old and have the authority to accept these Terms on behalf of your organisation. By using Nova, you represent that all registration information you submit is accurate and current.</p>
        </section>

        <section className="privacy-section" id="s4">
          <h2>4. User Accounts</h2>
          <ul>
            <li>You are responsible for maintaining the confidentiality of your account credentials.</li>
            <li>You must notify us immediately of any unauthorised use of your account.</li>
            <li>You are responsible for all activity that occurs under your account.</li>
          </ul>
        </section>

        <section className="privacy-section" id="s5">
          <h2>5. Acceptable Use</h2>
          <p>You agree not to use Nova to:</p>
          <ul>
            <li>Upload, transmit, or distribute any content that is unlawful, harmful, defamatory, or infringes intellectual property rights.</li>
            <li>Circumvent or disable any content guardrails, security, or access controls.</li>
            <li>Attempt to gain unauthorised access to Nova&apos;s systems or other users&apos; data.</li>
            <li>Use the Services for any purpose that violates applicable laws or regulations.</li>
            <li>Engage in any activity that degrades platform performance or interferes with other users.</li>
          </ul>
        </section>

        <section className="privacy-section" id="s6">
          <h2>6. Content Ownership</h2>
          <p>You retain ownership of all content you upload to Nova. By uploading content, you grant Nova a limited, non-exclusive licence to process and index that content solely to provide the Services.</p>
          <div className="privacy-highlight">We do not use your content to train AI models.</div>
        </section>

        <section className="privacy-section" id="s7">
          <h2>7. Guardrails &amp; Moderation</h2>
          <p>Nova applies automated content filters to prevent profanity, abuse, and off-topic usage. We reserve the right to suspend accounts that repeatedly violate content policies or acceptable use guidelines. Customisable guardrail policies are available on Professional and Enterprise plans.</p>
        </section>

        <section className="privacy-section" id="s8">
          <h2>8. Audit &amp; Compliance</h2>
          <p>All interactions on the Nova platform are logged and attributable to individual user accounts. These logs are accessible to your organisation&apos;s administrators and may be used for compliance, audit, and internal review purposes.</p>
        </section>

        <section className="privacy-section" id="s9">
          <h2>9. Payment &amp; Billing</h2>
          <ul>
            <li>Paid plans are billed monthly or annually as selected at signup.</li>
            <li>All fees are non-refundable except as required by applicable law.</li>
            <li>We reserve the right to change pricing with 30 days&apos; written notice.</li>
            <li>Prices shown on our website exclude applicable local taxes and are displayed in the currency determined by your location.</li>
          </ul>
        </section>

        <section className="privacy-section" id="s10">
          <h2>10. Intellectual Property</h2>
          <p>All rights, title, and interest in and to the Nova platform, including all software, designs, and documentation, are owned by Nova or its licensors. These Terms do not grant you any rights to Nova&apos;s intellectual property except the limited right to use the Services as described herein.</p>
        </section>

        <section className="privacy-section" id="s11">
          <h2>11. Disclaimer of Warranties</h2>
          <p>The Services are provided &quot;as is&quot; without warranties of any kind, express or implied. Nova does not warrant that the Services will be error-free, uninterrupted, or that AI-generated responses will always be accurate. You use the Services at your own risk.</p>
        </section>

        <section className="privacy-section" id="s12">
          <h2>12. Limitation of Liability</h2>
          <p>To the maximum extent permitted by law, Nova shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of the Services, even if advised of the possibility of such damages. Our total aggregate liability shall not exceed the amounts paid by you in the 12 months preceding the claim.</p>
        </section>

        <section className="privacy-section" id="s13">
          <h2>13. Termination</h2>
          <p>Either party may terminate these Terms at any time with written notice. Nova may suspend or terminate your access immediately if you violate these Terms. Upon termination, your right to use the Services ceases immediately and data will be handled in accordance with our Privacy Policy.</p>
        </section>

        <section className="privacy-section" id="s14">
          <h2>14. Governing Law</h2>
          <p>These Terms are governed by the laws of the State of California, USA, without regard to conflict-of-law provisions. Any disputes shall be resolved through binding arbitration or in the courts of San Francisco, California.</p>
        </section>

        <section className="privacy-section" id="s15">
          <h2>15. Changes to Terms</h2>
          <p>We reserve the right to modify these Terms at any time. We will provide at least 14 days&apos; written notice of material changes. Continued use of the Services after changes take effect constitutes your acceptance of the updated Terms.</p>
        </section>

        <section className="privacy-section" id="s16">
          <h2>16. Contact</h2>
          <p>For questions about these Terms, contact us at <a href="mailto:chatbot.bizacuity@bizacuity.ai">chatbot.bizacuity@bizacuity.ai</a>.</p>
        </section>
      </main>

      <ContactModal open={showContactModal} onClose={closeContactModal} />

      <footer className="privacy-footer">
        <p>
          <Link to="/landing" data-testid="terms-footer-home-link">Home</Link>
          <Link to="/privacypolicy" data-testid="terms-footer-privacy-policy-link">Privacy Policy</Link>
          <button type="button" className="footer-contact" onClick={openContactModal} data-testid="terms-footer-contact-button">
            Contact Us
          </button>
        </p>
        <p className="privacy-footer-copy">© {new Date().getFullYear()} Nova by BizAcuity. All rights reserved.</p>
      </footer>
    </div>
  );
}
